module.exports = __webpack_public_path__ + "static/media/question-green.33041ecb.svg";